(() => {
  const storageKey = 'bullseye-originals-mix-v1';
  const undoKey = 'bullseye-originals-surprise-v1';
  const escape = value => String(value).replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
  const money = cents => new Intl.NumberFormat('en-US', {style:'currency',currency:'USD'}).format(cents / 100);
  class OriginalsMix extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-global-mix') && document.querySelector('bc-originals-mix[data-global-mix]')) { this.remove(); return; }
      if (this.ready) return;
      this.ready = true;
      this.scope = this.hasAttribute('data-global-mix') ? document.body : this.closest('[data-mix-scope]') || this.closest('section');
      this.buttons = [...this.scope.querySelectorAll('[data-original-mix-add]')];
      this.designs = new Map(this.buttons.map(button => [button.dataset.designId, button.dataset.designTitle]));
      this.thumbnails = new Map();
      this.buttons.forEach(button => this.rememberCard(button));
      this.items = [];
      this.busy = false;
      this.fillBusy = false;
      this.surpriseAdded = new Map();
      this.innerHTML = `<div class="bc-mix-announcement" role="status" aria-live="polite"></div>
        <button class="bc-mix-bar" type="button" data-mix-review aria-label="Review Mix" aria-haspopup="dialog" hidden><span class="bc-mix-bar-copy"><strong data-mix-summary></strong><span data-mix-progress></span></span><span class="bc-mix-review-label">Review Mix</span></button>
        <dialog class="bc-mix-dialog" aria-labelledby="bc-mix-title"><div class="bc-mix-header"><h2 id="bc-mix-title">Your Coaster Mix</h2><button type="button" data-mix-close aria-label="Close your coaster mix">×</button></div>
        <p class="bc-mix-intro">Choose quantities for your favorites. Your total must be 20–360 coasters, in multiples of 20.</p>
        <section class="bc-mix-surprise"><button type="button" data-mix-surprise>Surprise Me — Fill My Tray</button><p data-surprise-plan></p><p class="bc-surprise-note">We’ll fill the gaps with Bullseye Originals. Your picks stay put. Repeats are possible.</p><button type="button" data-surprise-undo hidden>Undo Surprise</button><p data-surprise-status role="status" aria-live="polite"></p></section>
        <div class="bc-mix-items"></div><div class="bc-mix-totals"><strong data-mix-summary></strong><strong data-mix-price></strong></div>
        <p data-mix-offer style="color:#a91b15;font-weight:700"></p><p class="bc-mix-progress" data-mix-progress></p><p class="bc-mix-error" role="alert"></p>
        <div class="bc-mix-actions"><button type="button" data-mix-submit>Add Mix To Cart</button><button type="button" data-mix-close class="bc-mix-secondary">Keep Browsing</button></div>
        <button type="button" class="bc-mix-empty" data-mix-empty>Empty Tray</button><p class="bc-mix-pricing">$25 for the first 20. Each additional 20 is $20.</p></dialog>`;
      this.dialog = this.querySelector('dialog');
      this.restore();
      this.onScopeClick = event => {
        const surprise = event.target.closest('[data-mix-surprise-open]');
        if(surprise && this.scope.contains(surprise)) { this.update(); if(!this.dialog.open) this.dialog.showModal(); }

        const button = event.target.closest('[data-original-mix-add]');
        if (button && this.scope.contains(button)) {
          this.rememberCard(button);
          this.add(button.dataset.designId);
        }
        const addAll = event.target.closest('[data-mix-add-all]');
        if (addAll && this.scope.contains(addAll)) {
          const cards = addAll.closest('[data-product-mix]')?.querySelectorAll('[data-original-mix-add]') || [];
          cards.forEach(card => this.rememberCard(card));
          this.addDesigns([...cards].map(card => ({id:card.dataset.designId,title:card.dataset.designTitle,quantity:1})));
        }
      };
      this.scope.addEventListener('click', this.onScopeClick);
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-mix-review')) { this.dialog.showModal(); this.hydrateThumbnails(); }
        if (button.hasAttribute('data-mix-close')) this.dialog.close();
        if (button.hasAttribute('data-mix-surprise')) this.fillSurprise();
        if (button.hasAttribute('data-surprise-undo')) this.undoSurprise();
        if (button.dataset.mixRemove && !this.busy && !this.fillBusy) {
          this.querySelector('[data-surprise-status]').textContent = '';
          this.surpriseAdded.delete(button.dataset.mixRemove);
          const index = this.items.findIndex(item => item.id === button.dataset.mixRemove);
          this.items.splice(index, 1);
          this.save(); this.renderItems(); this.update();
          const fields = this.querySelectorAll('[data-mix-quantity]');
          (fields[Math.min(index, fields.length - 1)] || this.querySelector('[data-mix-close]')).focus();
        }
        if (button.hasAttribute('data-mix-empty') && !this.busy && !this.fillBusy) {
          this.items = []; this.surpriseAdded.clear(); this.save(); this.renderItems(); this.update();
          this.querySelector('[data-surprise-status]').textContent = '';
          this.querySelector('.bc-mix-error').textContent = '';
          this.querySelector('.bc-mix-announcement').textContent = 'Your tray is empty.';
          this.querySelector('.bc-mix-actions [data-mix-close]').focus();
        }
        if (button.hasAttribute('data-mix-submit')) this.submit();
      });
      this.addEventListener('error', event => {
        if (event.target.matches?.('.bc-mix-thumb img')) {
          const thumb = event.target.closest('.bc-mix-thumb');
          thumb.innerHTML = '<span class="bc-mix-thumb-fallback">Preview unavailable</span>';
        }
      }, true);
      this.addEventListener('input', event => {
        if (!event.target.hasAttribute('data-mix-quantity') || this.busy || this.fillBusy) return;
        const item = this.items.find(item => item.id === event.target.dataset.mixQuantity);
        const quantity = event.target.value === '' ? NaN : Number(event.target.value);
        if(!Number.isInteger(quantity) || quantity < 1) this.surpriseAdded.clear();
        else if(quantity < item.quantity) {
          const remaining = Math.max(0,(this.surpriseAdded.get(item.id) || 0) - (item.quantity - quantity));
          if(remaining) this.surpriseAdded.set(item.id,remaining); else this.surpriseAdded.delete(item.id);
        }
        item.quantity = quantity;
        this.querySelector('[data-surprise-status]').textContent = '';
        this.querySelector('.bc-mix-error').textContent = '';
        this.save(); this.update();
      });
      this.refreshCards();
      // A successful cart addition clears the draft, including when returning via browser Back.
      this.onPageShow = event => { if (event.persisted) this.restore(); };
      this.onStorage = event => { if (event.key === storageKey && !this.busy) this.restore(); };
      window.addEventListener('pageshow', this.onPageShow);
      window.addEventListener('storage', this.onStorage);
    }
    disconnectedCallback() {
      this.surpriseRequest?.abort();
      this.scope?.removeEventListener('click', this.onScopeClick);
      window.removeEventListener('pageshow', this.onPageShow);
      window.removeEventListener('storage', this.onStorage);
    }
    refreshCards() {
      this.buttons = [...this.scope.querySelectorAll('[data-original-mix-add]')];
      this.buttons.forEach(button => {
        this.rememberCard(button);
        button.hidden = false;
      });
      this.scope.querySelectorAll('[data-mix-add-all]').forEach(button => { button.hidden = false; });
      this.scope.querySelectorAll('[data-mix-surprise-open]').forEach(button => {button.hidden = false;});
      this.refreshThumbnails(); this.save(); this.update();
    }
    restore() {
      this.surpriseAdded = new Map();
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        const seen = new Set();
        this.items = Array.isArray(saved) ? saved.filter(item => {
          if (!item || !/^[0-9]{1,20}$/.test(item.id) || (!this.designs.has(item.id) && (typeof item.title !== 'string' || !item.title.trim() || item.title.length > 200)) || seen.has(item.id) || !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 360) return false;
          seen.add(item.id);
          const thumbnail = this.validThumbnail(item.thumbnail);
          if (thumbnail && !this.thumbnails.has(item.id)) this.thumbnails.set(item.id, thumbnail);
          if (!this.designs.has(item.id)) this.designs.set(item.id,item.title); return true;
        }).map(({id,quantity}) => ({id,quantity})) : [];
      } catch { this.items = []; }
      try {
        const undo = JSON.parse(localStorage.getItem(undoKey) || 'null');
        if(undo && JSON.stringify(undo.items) === JSON.stringify(this.items) && Array.isArray(undo.added)) {
          const seen = new Set();
          if(undo.added.every(row => Array.isArray(row) && row.length===2 && !seen.has(row[0]) && seen.add(row[0]) && Number.isInteger(row[1]) && row[1]>0 && row[1] <= (this.items.find(item=>item.id===row[0])?.quantity || 0))) this.surpriseAdded = new Map(undo.added);
        }
      } catch { /* Invalid undo data never changes a saved tray. */ }
      this.renderItems(); this.update();
    }
    save() {
      if (this.items.some(item => !Number.isInteger(item.quantity) || item.quantity < 1 || item.quantity > 360)) return;
      try {
        localStorage.setItem(storageKey, JSON.stringify(this.items.map(item => ({...item,title:this.designs.get(item.id),thumbnail:this.thumbnails.get(item.id)}))));
        if(this.surpriseAdded.size) localStorage.setItem(undoKey,JSON.stringify({items:this.items,added:[...this.surpriseAdded]}));
        else localStorage.removeItem(undoKey);
      } catch { /* Browsing still works when storage is unavailable. */ }
    }
    state() {
      const total = this.items.reduce((sum, item) => sum + item.quantity, 0);
      const whole = this.items.every(item => Number.isInteger(item.quantity) && item.quantity >= 1 && item.quantity <= 360);
      const valid = whole && total >= 20 && total <= 360 && total % 20 === 0;
      const next = Math.max(20, Math.ceil(total / 20) * 20);
      const progress = !whole || !Number.isFinite(total) ? 'Enter whole-number quantities from 1 to 360.'
        : total > 360 ? 'Maximum order: 360 coasters. Reduce your quantities.'
        : valid ? 'Your mix is ready.' : `Add ${next - total} more to reach ${next} coasters.`;
      return {total, valid, progress, price:valid ? 2500 + (total / 20 - 1) * 2000 : null};
    }
    add(id) {
      if (!this.designs.has(id)) return;
      return this.addDesigns([{id,title:this.designs.get(id),quantity:1}]);
    }
    addDesigns(designs) {
      if (this.busy || this.fillBusy || !designs.length || designs.some(item => !/^[0-9]{1,20}$/.test(item.id) || typeof item.title !== 'string' || !item.title.trim() || !Number.isInteger(item.quantity) || item.quantity < 1)) return false;
      this.querySelector('[data-surprise-status]').textContent = '';
      const state = this.state();
      const added = designs.reduce((sum,item) => sum + item.quantity,0);
      if (!Number.isFinite(state.total) || state.total + added > 360 || this.items.some(item => !Number.isInteger(item.quantity) || item.quantity < 1)) {
        this.dialog.showModal();
        this.querySelector('.bc-mix-error').textContent = state.total + added > 360 ? `There is not room for ${added} more. Your tray can hold up to 360 coasters.` : 'Adjust the quantities in your mix before adding another coaster.';
        return false;
      }
      designs.forEach(design => {
        this.designs.set(design.id,design.title);
        const item = this.items.find(item => item.id === design.id);
        if (item) item.quantity += design.quantity; else this.items.push({id:design.id,quantity:design.quantity});
      });
      this.save(); this.renderItems(); this.update();
      this.querySelector('.bc-mix-error').textContent = '';
      this.querySelector('.bc-mix-announcement').textContent = `${designs.length === 1 ? designs[0].title : `${added} coasters`} added. ${this.state().total} coasters in your mix.`;
      return true;
    }
    surprisePlan() {
      const {total} = this.state();
      const valid = Number.isInteger(total) && total>=0 && total<360 && this.items.every(item=>Number.isInteger(item.quantity) && item.quantity>=1);
      const target = valid ? (Math.floor(total/20)+1)*20 : null;
      return {valid,target,add:valid ? target-total : 0,price:valid ? 2500+(target/20-1)*2000 : null};
    }
    async loadOriginals(signal) {
      // Eligibility comes from live, available standalone products in the Originals collection.
      const pool = new Map(), visited = new Set();
      let next = '/collections/bullseye-originals';
      while(next) {
        const url = new URL(next,window.location.origin);
        if(url.origin!==window.location.origin || url.pathname!=='/collections/bullseye-originals' || visited.has(url.href) || visited.size>=250) throw Error('The Originals list could not be loaded. Please try again.');
        visited.add(url.href);
        const response = await fetch(url.href,{signal});
        if(!response.ok) throw Error('The Originals list could not be loaded. Please try again.');
        const page = new DOMParser().parseFromString(await response.text(),'text/html');
        const catalog = page.querySelector('[data-surprise-catalog]');
        if(!catalog) throw Error('The Originals list could not be loaded. Please try again.');
        catalog.querySelectorAll('[data-surprise-original][data-original-mix-add]').forEach(button => {
          const id=button.dataset.designId,title=button.dataset.designTitle;
          if(!/^[0-9]{1,20}$/.test(id) || !title?.trim() || title.length>200) return;
          this.rememberCard(button);
          pool.set(id,{id,title});
        });
        next=catalog.dataset.nextUrl;
      }
      if(!pool.size) throw Error('No Bullseye Originals are available for a surprise mix right now. Your picks are unchanged.');
      return [...pool.values()];
    }
    async fillSurprise() {
      const plan=this.surprisePlan();
      if(this.busy || this.fillBusy || !plan.valid) return;
      const before=JSON.stringify(this.items);
      this.fillBusy=true; this.update();
      this.querySelector('[data-surprise-status]').textContent='Choosing your Bullseye Originals…';
      this.surpriseRequest=new AbortController();
      const timeout=setTimeout(()=>this.surpriseRequest?.abort(),20000);
      try {
        const pool=await this.loadOriginals(this.surpriseRequest.signal);
        if(!this.isConnected) return;
        if(JSON.stringify(this.items)!==before) throw Error('Your tray changed while we were choosing. Review the new total and try again.');
        const counts=new Map(pool.map(item=>[item.id,this.items.find(existing=>existing.id===item.id)?.quantity || 0]));
        const additions=new Map();
        for(let i=0;i<plan.add;i++) {
          const minimum=Math.min(...counts.values());
          const choices=pool.filter(item=>counts.get(item.id)===minimum);
          const pick=choices[Math.floor(Math.random()*choices.length)];
          counts.set(pick.id,counts.get(pick.id)+1);
          const added=additions.get(pick.id) || {...pick,quantity:0};added.quantity++;additions.set(pick.id,added);
        }
        this.fillBusy=false;
        if(!this.addDesigns([...additions.values()])) throw Error('Your tray could not be filled. Please review your quantities.');
        this.surpriseAdded=new Map([...additions.values()].map(item=>[item.id,item.quantity]));
        this.save();this.update();
        this.querySelector('[data-surprise-status]').textContent=`Added ${plan.add} Bullseye Originals. Your tray now has ${plan.target} coasters for ${money(plan.price)}. Review or adjust them below.`;
        this.hydrateThumbnails();
      } catch(error) {
        if(this.isConnected) this.querySelector('[data-surprise-status]').textContent=error.name==='AbortError' ? 'The Originals list took too long to load. Your picks are unchanged. Please try again.' : error.message;
      } finally {clearTimeout(timeout);this.fillBusy=false;this.surpriseRequest=null;if(this.isConnected)this.update();}
    }
    undoSurprise() {
      if(this.busy || this.fillBusy || !this.surpriseAdded.size) return;
      const removed=[...this.surpriseAdded.values()].reduce((a,b)=>a+b,0);
      this.items=this.items.map(item=>({...item,quantity:item.quantity-(this.surpriseAdded.get(item.id)||0)})).filter(item=>item.quantity>0);
      this.surpriseAdded.clear();this.save();this.renderItems();this.update();
      this.querySelector('[data-surprise-status]').textContent=`Removed ${removed} surprise coasters. Your own picks are still in the tray.`;
    }
    validThumbnail(value) {
      if (!value || typeof value.src !== 'string' || value.src.length > 2048) return null;
      try {
        const url = new URL(value.src, window.location.origin);
        if (url.protocol !== 'https:' || url.username || url.password || !(url.origin === window.location.origin || url.hostname === 'cdn.shopify.com')) return null;
        const crop = {};
        for (const key of ['w','h','x','y']) {
          if (typeof value[key] !== 'string' || !/^-?\d+(?:\.\d+)?%$/.test(value[key]) || Math.abs(parseFloat(value[key])) > 2000) return null;
          if ((key === 'w' || key === 'h') && parseFloat(value[key]) <= 0) return null;
          crop[key] = value[key];
        }
        return {src:url.href,...crop};
      } catch { return null; }
    }
    rememberCard(button) {
      this.designs.set(button.dataset.designId, button.dataset.designTitle);
      const face = button.closest('article')?.querySelector('.bs-single-preview .bs-cascade-face');
      const image = face?.querySelector('img');
      if (!image) return;
      const value = {src:image.getAttribute('src')};
      for (const key of ['w','h','x','y']) value[key] = face.style.getPropertyValue(`--image-${key}`).trim();
      const thumbnail = this.validThumbnail(value);
      if (thumbnail) this.thumbnails.set(button.dataset.designId, thumbnail);
    }
    thumbnailMarkup(item) {
      const thumbnail = this.thumbnails.get(item.id);
      if (!thumbnail) return '<span class="bc-mix-thumb-fallback">Coaster preview</span>';
      return `<span class="bc-mix-thumb-face"><img src="${escape(thumbnail.src)}" alt="${escape(this.designs.get(item.id))}" loading="lazy" decoding="async" style="width:${thumbnail.w};height:${thumbnail.h};left:${thumbnail.x};top:${thumbnail.y}"></span>`;
    }
    refreshThumbnails() {
      this.querySelectorAll('.bc-mix-thumb').forEach(thumb => {
        if (!thumb.querySelector('img') && this.thumbnails.has(thumb.dataset.thumbnailId)) thumb.innerHTML = this.thumbnailMarkup({id:thumb.dataset.thumbnailId});
      });
    }
    async hydrateThumbnails() {
      // Older saved trays contain names only. Recover their exact front-face crops from the catalog.
      const missing = () => this.items.some(item => !this.thumbnails.has(item.id));
      if (!missing() || this.loadingThumbnails) return;
      this.loadingThumbnails = true;
      const read = root => root.querySelectorAll('template[data-mix-design]').forEach(template => {
        if (!this.items.some(item => item.id === template.dataset.id)) return;
        const button = template.content.querySelector('[data-original-mix-add]');
        if (button) this.rememberCard(button);
      });
      try {
        read(document);
        let next = '/collections/individual-coasters';
        const visited = new Set();
        while (missing() && next && this.isConnected) {
          const url = new URL(next, window.location.origin);
          if (url.origin !== window.location.origin || url.pathname !== '/collections/individual-coasters' || visited.has(url.href)) break;
          visited.add(url.href);
          const response = await fetch(url.href);
          if (!response.ok) break;
          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          read(page);
          next = page.querySelector('[data-mix-catalog-data]')?.dataset.nextUrl;
        }
      } catch { /* A saved mix remains editable if artwork cannot be loaded. */ }
      finally { this.loadingThumbnails = false; if (this.isConnected) { this.refreshThumbnails(); this.save(); } }
    }
    renderItems() {
      this.querySelector('.bc-mix-items').innerHTML = this.items.map(item => {
        const title = this.designs.get(item.id), caption = title.split(' — ').at(-1);
        return `<div class="bc-mix-row"><div class="bc-mix-thumb" data-thumbnail-id="${escape(item.id)}">${this.thumbnailMarkup(item)}</div><p class="bc-mix-caption" title="${escape(title)}">${escape(caption)}</p><div class="bc-mix-quantity-control"><label for="mix-qty-${escape(item.id)}">Qty</label><input id="mix-qty-${escape(item.id)}" data-mix-quantity="${escape(item.id)}" aria-label="Quantity for ${escape(title)}" type="number" min="1" max="360" step="1" inputmode="numeric" value="${Number.isFinite(item.quantity) ? item.quantity : ''}"></div><button type="button" data-mix-remove="${escape(item.id)}" aria-label="Remove ${escape(title)}">×</button></div>`;
      }).join('') || '<p class="bc-mix-empty-state">Your mix is empty. Add a design to get started.</p>';
    }
    update() {
      const state = this.state();
      const locked=this.busy || this.fillBusy, plan=this.surprisePlan();
      const surprise=this.querySelector('[data-mix-surprise]');
      surprise.hidden=Number.isFinite(state.total) && state.total>=360;
      surprise.disabled=locked || !plan.valid;
      surprise.textContent=this.fillBusy ? 'Choosing Your Originals…' : 'Surprise Me — Fill My Tray';
      this.querySelector('[data-surprise-plan]').textContent=plan.valid ? `Add ${plan.add} coasters → ${plan.target} total · ${money(plan.price)}` : state.total>=360 ? 'Your tray has reached the 360-coaster limit.' : 'Enter valid whole-number quantities before filling your tray.';
      const undo=this.querySelector('[data-surprise-undo]');undo.hidden=!this.surpriseAdded.size;undo.disabled=locked;
      this.scope.querySelectorAll('[data-mix-surprise-open]').forEach(button=>{button.disabled=locked || !plan.valid;button.hidden=state.total>=360;});
      this.querySelector('.bc-mix-bar').hidden = this.items.length === 0;
      this.querySelectorAll('[data-mix-summary]').forEach(element => { element.textContent = `${Number.isFinite(state.total) ? state.total : '—'} ${state.total === 1 ? 'coaster' : 'coasters'}`; });
      this.querySelectorAll('[data-mix-progress]').forEach(element => { element.textContent = state.progress; });
      this.querySelector('[data-mix-price]').textContent = state.valid ? money(state.price) : '—';
      this.querySelector('[data-mix-offer]').textContent = state.valid ? `${money(state.price - 500)} with code 20FOR20 at checkout. Your picks. Your mix.` : Number.isFinite(state.total) && state.total < 20 ? `${20 - state.total} more to make your $20 mix. Use code 20FOR20 at checkout.` : '20 coasters. 20 bucks. Use code 20FOR20 at checkout.';
      this.querySelector('[data-mix-empty]').disabled = locked || !this.items.length;
      const submit = this.querySelector('[data-mix-submit]');
      submit.disabled = !state.valid || locked;
      submit.textContent = this.busy ? 'Adding Your Mix…' : 'Add Mix To Cart';
      this.querySelectorAll('[data-mix-quantity],[data-mix-remove]').forEach(element => { element.disabled = locked; });
      this.buttons.forEach(button => { button.disabled = locked; });
      this.scope.querySelectorAll('[data-mix-add-all]').forEach(button => { button.disabled = locked; });
      this.scope.querySelectorAll('[data-mix-count-for]').forEach(element => {
        const quantity = this.items.find(item => item.id === element.dataset.mixCountFor)?.quantity;
        element.textContent = Number.isInteger(quantity) && quantity > 0 ? `${quantity} in your mix` : '';
      });
    }
    async submit() {
      const state = this.state();
      if (this.busy || this.fillBusy || !state.valid) return;
      this.busy = true; this.update();
      this.querySelector('.bc-mix-error').textContent = '';
      let addingToCart = false;
      try {
        const key = crypto.randomUUID().replaceAll('-', '') + crypto.randomUUID().replaceAll('-', '');
        const response = await fetch(`${this.getAttribute('api-base')}/ready-made-order`, {method:'POST',headers:{'Content-Type':'application/json','X-Design-Key':key},body:JSON.stringify({designs:this.items.map(({id,quantity})=>({id,quantity}))})});
        const result = await response.json();
        if (!response.ok) throw Error(result.error || 'Your mix could not be prepared. Please try again.');
        if (!result.cartItem || result.total !== state.total || result.totalPrice !== state.price) throw Error('Pricing has changed. Refresh the page before adding your mix.');
        addingToCart = true;
        const root = window.Shopify?.routes?.root || '/';
        const cart = await fetch(`${root}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[result.cartItem]})});
        const added = await cart.json();
        addingToCart = false;
        if (!cart.ok) throw Error(added.description || 'Your mix could not be added. Please try again.');
        this.items = []; this.surpriseAdded.clear(); this.save(); this.renderItems();
        this.dialog.close();
        window.location.href = `${root}cart`;
      } catch (error) {
        this.querySelector('.bc-mix-error').textContent = addingToCart ? 'We could not confirm the cart update. Check your cart before trying again.' : error.message;
      } finally { this.busy = false; this.update(); }
    }
  }
  if (!customElements.get('bc-originals-mix')) customElements.define('bc-originals-mix', OriginalsMix);
})();
